import { CloudinaryImage_File, Maybe } from 't2-graphql-types';
import React, { FC } from 'react';
import { DEFAULT_ARTICLE_IMAGE } from '../ArticleCard/constants';
import CloudinaryResponsiveImage from '../CloudinaryResponsiveImage/CloudinaryResponsiveImage';

type IArticleCoverImageProps = {
  coverImage: Maybe<CloudinaryImage_File>;
};

const ArticleCoverImage: FC<IArticleCoverImageProps> = ({ coverImage }) => (
  <div className="relative w-full mb-4 md:rounded-xl overflow-hidden aspect-4/2">
    {coverImage ? (
      <CloudinaryResponsiveImage image={coverImage} alt="article cover" className="absolute object-cover w-full" />
    ) : (
      <img className="min-w-full min-h-full" src={DEFAULT_ARTICLE_IMAGE} alt="article cover" />
    )}
  </div>
);

export default ArticleCoverImage;
